import { Component, ViewChild } from '@angular/core'
import { NgbNav, NgbNavItem, NgbNavItemRole, NgbNavLink, NgbNavLinkBase } from '@ng-bootstrap/ng-bootstrap'

import { BaseComponent, FeatureType } from '../../shared'
import { JobHazardAnalysisDashboardComponent } from './job-hazard-analysis-dashboard.component'
import { JobHazardAnalysisListComponent } from './job-hazard-analysis-list.component'

@Component({
    selector: 'app-job-hazard-analysis',
    templateUrl: './job-hazard-analysis.component.html',
    standalone: true,
    imports: [
        NgbNav,
        NgbNavItem,
        NgbNavItemRole,
        NgbNavLink,
        NgbNavLinkBase,
        JobHazardAnalysisDashboardComponent,
        JobHazardAnalysisListComponent,
    ],
})
export class JobHazardAnalysisComponent extends BaseComponent {
    @ViewChild(JobHazardAnalysisDashboardComponent)
    dashboard?: JobHazardAnalysisDashboardComponent

    @ViewChild(JobHazardAnalysisListComponent)
    list?: JobHazardAnalysisListComponent

    activeTab = 0

    constructor() {
        super()
        // Users without dashboard access land directly on the Records tab.
        this.activeTab = this.canViewDashboard ? 0 : 1
        this.initialLoadingComplete()
    }

    tabChanged() {
        if (this.isDashboardTab) {
            this.dashboard?.refresh()
        }
    }

    onAddForJob(event: { jobId: string; jobName: string }) {
        void this.list?.openAddForJob(event.jobId, event.jobName)?.then(() => {
            this.dashboard?.refresh()
        })
    }

    get canViewDashboard() {
        return this.services.authentication.hasFeature([FeatureType.SafetyJobHazardAnalysisDashboardView])
    }

    get isDashboardTab() {
        return Number(this.activeTab) === 0
    }

    get isRecordsTab() {
        return Number(this.activeTab) === 1
    }
}
